// extracted by mini-css-extract-plugin
export default {"hideTooltip":"v9-z","fadeIn":"w9-z","delay":"x9-z","recommendedSizeTooltip":"y9-z"};